<template>
  <div>
    <v-row>
      <v-col>
        <v-card
          class="d-flex flex-wrap justify-space-between"
        >
          <v-card
            class="pa-3"
            flat
          >
            <tw-agendamento-cadastro
              @update="onUpdate"
            >
              <template v-slot:activator="{ on }">
                <v-btn color="primary" class="mr-2" v-on="on">
                  <v-icon>mdi-plus</v-icon>
                  Novo Agendamento
                </v-btn>
              </template>
            </tw-agendamento-cadastro>
          </v-card>
          <v-card
            class="pa-3 align-self-center"
            flat
          >
            <v-btn
              class="float-left"
              icon @click="getAgendamentos">
              <v-icon center>mdi-refresh</v-icon>
            </v-btn>
            <tw-search-text
              label="Busque por um agendamento"
              v-model="searchText"
              style="max-width: 400px; width: 350px;"
              :on-search="onChangeFilter"/>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
    <div v-if="loading">
      <tw-circular-loading/>
    </div>
    <div v-if="!loading && (!agendamentos || !agendamentos.total)"
         align="center"
         class="headline mb-5 mt-10">
      <!--      Nenhuma agendamento encontrado.-->
      <v-spacer></v-spacer>
      <tw-agendamento-cadastro
        @update="onUpdate"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            color="green"
            dark
            v-on="on"
          >
            Clique aqui realizar um agendamento
          </v-btn>
        </template>
      </tw-agendamento-cadastro>
    </div>
    <div v-if="!loading && agendamentos && agendamentos.total">
      <v-row dense>
        <v-col>
          <v-list two-line subheader>
            <template v-for="agendamento in agendamentos.content">
              <tw-agendamento-item
                :key="agendamento.id"
                :agendamento="agendamento"
                @update="onUpdate"
                @remove="onRemove"
              />
            </template>
          </v-list>
        </v-col>
      </v-row>
      <div class="text-center">
        <v-pagination
          v-model="page"
          :length="pagesLimit"
          :total-visible="8"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import AgendamentoService from '@/api/agendamento-service';
import AgendamentoItem from '@/modules/agendamento/AgendamentoItem.vue';
import paginationMixin from '@/mixins/pagination-mixin';
import AgendamentoCadastro from './cadastro/AgendamentoCadastro.vue';

const LIMIT = 10;
const PAGE = 1;

export default {
  mixins: [paginationMixin],
  data: () => ({
    page: PAGE,
    pagesLimit: 1,
    searchText: null,
    loading: false,
    agendamentos: {
      content: [],
      total: 0,
    },
    listOptions: {
      page: PAGE,
      limit: LIMIT,
      offset: 0,
      filter: '',
      sort: 'cliente.nome',
      sortDesc: false,
    },
    optionsList: {
      page: PAGE,
      itemsPerPage: LIMIT,
      sortBy: '',
      sortDesc: false,
      multiSort: false,
    },
  }),
  created() {
    this.getAgendamentos();
  },
  methods: {
    buildSearchFilter(filters) {
      if (!filters.searchText) {
        return '';
      }
      return `(cliente.nome like "%${filters.searchText.toLowerCase()}%" or cliente.email like "%${filters.searchText.toLowerCase()}%" or cliente.celular like "%${filters.searchText.toLowerCase()}%")`;
    },
    onChangeFilter() {
      this.listOptions.filter = this.buildSearchFilter({ searchText: this.searchText });
      this.resetPage();
      this.getAgendamentos();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    onUpdate() {
      this.getAgendamentos();
    },
    getAgendamentos() {
      this.listOptions.sort = 'cliente.nome';
      this.loading = true;
      const {
        limit,
        offset,
      } = this.listOptions;
      AgendamentoService.list({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then(({ data }) => {
          this.agendamentos = data;
          this.setPagesLimit();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setPagesLimit() {
      this.pagesLimit = Math.ceil(this.agendamentos.total / LIMIT);
    },
    onChangeOptions() {
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getAgendamentos();
    },
    onRemove(item) {
      this.loading = true;
      AgendamentoService.remove(item.id)
        .then(() => {
          this.$toast('Agendamento removido com sucesso', { color: 'success' });
          this.getAgendamentos();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  components: {
    twAgendamentoCadastro: AgendamentoCadastro,
    twAgendamentoItem: AgendamentoItem,
  },
  watch: {
    page(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.optionsList.page = newValue;
      this.onChangeOptions();
    },
  },
};
</script>
